import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { BLUEPRINT_TYPES } from "./constants";

export function BlueprintEditDialog({ editBlueprint, editData, setEditData, onUpdate, onClose }) {
  if (!editBlueprint) return null;

  return (
    <Dialog open={!!editBlueprint} onOpenChange={onClose}>
      <DialogContent className="bg-white rounded-none border border-[#E2E8F0]" aria-describedby="edit-description">
        <DialogHeader>
          <DialogTitle className="font-heading font-bold text-[#0F172A]">Edit Blueprint</DialogTitle>
        </DialogHeader>
        <div id="edit-description" className="sr-only">Edit blueprint information</div>
        <div className="space-y-4">
          <div>
            <Label className="text-[#0F172A]">Machine Number</Label>
            <Input
              value={editData.machine_number}
              onChange={(e) => setEditData({ ...editData, machine_number: e.target.value })}
              className="mt-1 rounded-none border-[#E2E8F0] font-mono"
              data-testid="edit-machine-number"
            />
          </div>
          <div>
            <Label className="text-[#0F172A]">Type</Label>
            <Select
              value={editData.blueprint_type}
              onValueChange={(value) => setEditData({ ...editData, blueprint_type: value })}
            >
              <SelectTrigger className="mt-1 rounded-none border-[#E2E8F0]" data-testid="edit-type-select">
                <SelectValue placeholder="Select type" />
              </SelectTrigger>
              <SelectContent className="bg-white rounded-none border border-[#E2E8F0]">
                {Object.entries(BLUEPRINT_TYPES).map(([key, { label }]) => (
                  <SelectItem key={key} value={key}>{label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-[#0F172A]">Status</Label>
            <Select
              value={editData.status}
              onValueChange={(value) => setEditData({ ...editData, status: value })}
            >
              <SelectTrigger className="mt-1 rounded-none border-[#E2E8F0]" data-testid="edit-status-select">
                <SelectValue placeholder="Select status" />
              </SelectTrigger>
              <SelectContent className="bg-white rounded-none border border-[#E2E8F0]">
                <SelectItem value="pending">Pending</SelectItem>
                <SelectItem value="categorized">Categorized</SelectItem>
                <SelectItem value="missing">Missing</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-[#0F172A]">Classification (ITAR)</Label>
            <Select
              value={editData.classification || ""}
              onValueChange={(value) => setEditData({ ...editData, classification: value })}
            >
              <SelectTrigger className="mt-1 rounded-none border-[#E2E8F0]" data-testid="edit-classification-select">
                <SelectValue placeholder="Select classification" />
              </SelectTrigger>
              <SelectContent className="bg-white rounded-none border border-[#E2E8F0]">
                <SelectItem value="unclassified">Unclassified</SelectItem>
                <SelectItem value="cui">CUI (Controlled Unclassified)</SelectItem>
                <SelectItem value="ouo">OUO (Official Use Only)</SelectItem>
                <SelectItem value="itar">ITAR (Export Controlled)</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-[#0F172A]">Notes</Label>
            <Input
              value={editData.notes}
              onChange={(e) => setEditData({ ...editData, notes: e.target.value })}
              className="mt-1 rounded-none border-[#E2E8F0]"
              data-testid="edit-notes"
            />
          </div>
          <Button
            onClick={onUpdate}
            className="w-full bg-[#2563EB] hover:bg-[#0F172A] text-white rounded-none"
            data-testid="update-blueprint-button"
          >
            UPDATE
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
